import React, { useEffect, useState, FC, memo, useContext } from "react";
import { useTranslation } from "react-i18next";
import isEmpty from "lodash/isEmpty";
import { useAppSelector } from "@/redux/store";
import { commonLoaderStyle, LOADER_TYPES } from "@/constants";
import Loader from "../../loader";
import { productErrorContext } from "../webSizes/productWebSizes";
import { AddToCartButtonProps } from "./types";
import "./style.scss";

const TIMEOUT_DELAY = 1000;

const loaderStyle = {
  ...commonLoaderStyle
};

const AddToCartButton: FC<AddToCartButtonProps> = ({
  product,
  selectedSize,
  handleAddToCart
}) => {
  const { t, ready } = useTranslation("productDetails", { useSuspense: false });
  const isSaving = useAppSelector(state => state.cartReducer?.isSaving);
  const [buttonText, setButtonText] = useState(t("addToCart"));
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const { setSelectSizeFirstError } = useContext(productErrorContext);
  const isButtonDisabled = !Boolean(product.pstock) || buttonDisabled;

  useEffect(() => {
    setButtonText(t("addToCart"));
  }, [ready]);

  useEffect(() => {
    if (isSaving) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  }, [isSaving]);

  const onAddToCartClick = async () => {
    if (isEmpty(selectedSize)) {
      setSelectSizeFirstError(true);
      return;
    }

    const resp = await handleAddToCart();

    if (resp?.status === 200) {
      setButtonText(t("addedToCart"));
      setTimeout(() => setButtonText(t("addToCart")), TIMEOUT_DELAY);
    }
  };

  return (
    <button
      className="add_to_cart_button"
      onClick={onAddToCartClick}
      disabled={isButtonDisabled}
    >
      {isSaving ? (
        <Loader
          type={LOADER_TYPES.DOTS}
          width={25}
          height={25}
          visible
          style={loaderStyle}
        />
      ) : (
        buttonText
      )}
    </button>
  );
};

export default memo(AddToCartButton);
